import { Provider } from "mobx-react";
import {
  commonsStore,
  CommonsStore,
  commonsStoreContext
} from "./CommonsStore";
import React, {
  FunctionComponent,
  PropsWithChildren,
  ReactElement
} from "react";
import { identity18n, I18n, i18nContext } from "./I18n";
import { LoggerFactory } from "../logger";

export interface LegoProviderProps {
  commons?: CommonsStore;
  i18n?: I18n | Promise<I18n>;
}

export const LegoProvider: FunctionComponent<LegoProviderProps> = (
  props: PropsWithChildren<LegoProviderProps>
): ReactElement => {
  const stores = { ...props };
  const log = LoggerFactory.create("LegoProvider");
  const CommonsProvider = commonsStoreContext.Provider;
  const I18nProvider = i18nContext.Provider;

  if (!stores.commons) {
    stores.commons = commonsStore;
  }

  if (!stores.i18n) {
    stores.i18n = identity18n;
  }

  log.debug("providing stores:", stores);

  return (
    <CommonsProvider value={stores.commons}>
      <I18nProvider value={stores.i18n as I18n}>
        <Provider {...stores}>{props.children}</Provider>
      </I18nProvider>
    </CommonsProvider>
  );
};
